export { en, type TranslationKeys } from './en';
export { fa } from './fa';

export type Language = 'en' | 'fa';

export const languages: Record<Language, { name: string; nativeName: string; dir: 'ltr' | 'rtl' }> = {
  en: { name: 'English', nativeName: 'English', dir: 'ltr' },
  fa: { name: 'Persian', nativeName: 'فارسی', dir: 'rtl' },
};
